import React, { useState } from 'react';
import { Card, CardContent, Typography, Button, Box, Container } from '@mui/material';
import Input from '../../common/form/input';
import Timer from '../../common/timer/index';
import SendIcon from '@mui/icons-material/Send';
import { PropTypes } from 'prop-types';
import { useEffect } from 'react';
import BasicModal from '../../common/modal';
import TermsAndConditions from '../terms-and-conditions';
import CloseIcon from '@mui/icons-material/Close';
import { trackDealerEvents } from '../../../tracking';

const LoginOtp = ({ handleVerify, handleChangeNumber, otpLength = 4, otpError, handleResendOtp, mobile }) => {
    const [showLoader, setShowLoader] = useState(true);
    const [otp, setOtp] = useState('');
    const [showTnc, setShowTnc] = useState(false);

    const handleTimerComplete = () => {
        setShowLoader(false);
    };

    useEffect(() => {
        if (otp && otp.length === otpLength) {
            trackDealerEvents('verifyOtp', { phone: mobile, otp });
            handleVerify(otp);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [otp]);

    const handleChange = (event) => {
        const { value } = event?.target || {};
        if (value?.length <= otpLength) {
            setOtp(value);
        }
    };

    const handleResend = () => {
        trackDealerEvents('resentOtp', { phone: mobile });
        setShowLoader(true);
        setOtp('');
        handleResendOtp();
    };

    const handleTnCNavigation = () => {
        setShowTnc(true);
    };
    const enableVerify = otp?.length === otpLength;
    const phoneNumber = `${mobile}`.substring(mobile?.length - 2);
    return (
        <Card elevation={3} className='rounded-lg'>
            <CardContent className='py-6'>
                <Typography variant="body2" align="left" className='font-semibold text-border'>
                    Please enter the OTP sent to mobile number &nbsp;<span className='font-semibold inline-block text-text'>***{phoneNumber}</span>
                </Typography>
                <Input inputType='tel' value={otp} onChange={handleChange} className="w-full mt-4 mb-2" placeholder="Enter OTP" helperText={otpError || ''} error={otpError} />
                <Typography variant="subtitle2" align="left" className='mt-3 mb-1'>
                    By clicking verify, I accept <span className='text-primary' onClick={handleTnCNavigation}>Terms & Conditions</span>
                </Typography>
                <Button disabled={!enableVerify} onClick={handleVerify.bind(null, otp)} variant="contained" color='secondary' fullWidth className='mb-4 py-3 font-bold text-base'>Verify OTP</Button>
                <Box className='flex justify-between'>
                    <Button onClick={handleChangeNumber} color='primary' size='small' className='font-bold'>
                        Change number
                    </Button>
                    <Button onClick={handleResend} disabled={showLoader} color='primary' size='small' className='font-bold' endIcon={showLoader ? <Timer onComplete={handleTimerComplete} interval={30} onlyText={false} /> : <SendIcon color='primary' sx={{ fontSize: '14px!important' }} />}>
                        Resend
                    </Button>
                </Box>
            </CardContent>
            {showTnc && <BasicModal sx={{ overflow: 'scroll' }} extraStyle={{ height: 'auto' }} open={showTnc}>
                <Container className='bg-white py-6 relative'>
                    <CloseIcon className='fixed right-4 top-2 w-7 h-7' onClick={setShowTnc.bind(null, false)} />
                    <TermsAndConditions />
                </Container>
            </BasicModal>}
        </Card>
    );
};

LoginOtp.propTypes = {
    otpError: PropTypes.string,
    otpLength: PropTypes.number,
    mobile: PropTypes.number,
    handleVerify: PropTypes.func,
    handleChangeNumber: PropTypes.func,
    handleResendOtp: PropTypes.func
};

export default LoginOtp;
